/**
 * SSO token provider: allows the API client to obtain the current Azure AD access token
 * when the user signed in via SSO. Set by MsalProvider when the app mounts.
 */
let ssoTokenGetter: (() => Promise<string | null>) | null = null;

export function setSsoTokenGetter(getter: (() => Promise<string | null>) | null): void {
  ssoTokenGetter = getter;
}

export async function getSsoToken(): Promise<string | null> {
  if (!ssoTokenGetter) {
    if (import.meta.env.DEV) {
      console.warn('[sso] getSsoToken called but no token getter is registered (MsalProvider not mounted yet?)');
    }
    return null;
  }
  try {
    const token = await ssoTokenGetter();
    if (!token && import.meta.env.DEV) {
      console.warn('[sso] token getter returned null (silent token acquisition failed?)');
    }
    return token;
  } catch (e) {
    // A thrown error here usually means MSAL silent acquisition failed (e.g. interaction required).
    console.warn('[sso] token getter threw; falling back to stored token', e);
    return null;
  }
}
